import { css } from '@emotion/react'
import ProviderIcon from 'components/App/DesktopView/Layout/TicketInspector/Changesets/ExpandedMessage/ProviderIcon'

const cssIntegrationEvent = () => theme => css`
  font-size: 13px;
  color: ${theme.color.monochrome.mediumDark};
  text-align: center;

  .ProviderIcon img {
    float: none;
    margin-right: 4px;
  }
`

export default function IntegrationEventWrapper({ children, provider }) {
  return (
    <div css={cssIntegrationEvent}>
      <ProviderIcon provider={provider} />
      {children}
    </div>
  )
}
